import type { GraphEdge, GraphNode, OwnershipGraphData } from '../../../types'
import { isDownstreamOfRoot, isUpstreamOfRoot } from './graphExpandCone'

export function canExpandUp(node: GraphNode, rootId: string, edges: GraphEdge[]): boolean {
  return !!(
    node.truncated
    && node.kind === 'company'
    && node.cvrNummer
    && isUpstreamOfRoot(node.id, rootId, edges)
  )
}

export function canExpandDownRoot(data: OwnershipGraphData): boolean {
  const rootId = 'cvr:' + data.rootCvr
  const root = data.nodes.find(n => n.id === rootId)
  return !!(data.hasDownstream || (root?.truncated && root.cvrNummer))
}

export function canExpandDown(node: GraphNode, rootId: string, edges: GraphEdge[]): boolean {
  if (node.isRoot) return false
  return !!(
    node.truncated
    && node.kind === 'company'
    && node.cvrNummer
    && isDownstreamOfRoot(node.id, rootId, edges)
  )
}
